import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 6a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2l0 -4","key":"svg-0"}],["path",{"d":"M12 2v2","key":"svg-1"}],["path",{"d":"M9 12v9","key":"svg-2"}],["path",{"d":"M15 12v9","key":"svg-3"}],["path",{"d":"M5 16l4 -2","key":"svg-4"}],["path",{"d":"M15 14l4 2","key":"svg-5"}],["path",{"d":"M9 18h6","key":"svg-6"}],["path",{"d":"M10 8v.01","key":"svg-7"}],["path",{"d":"M14 8v.01","key":"svg-8"}]]

const IconRobot = createReactComponent('outline', 'robot', 'Robot', __iconNode);

export default IconRobot;